import React from 'react';
import { Redirect, Route } from 'react-router';
import { useSubscription } from '@meraki-internal/state';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CarePage } from '../care/CarePage';
import { CareStatusPage } from '../care/status/CareStatusPage';
import { CareTabsProvider } from '../care/CareTabsProvider';
import { CareMapState } from '../caremap/CareMapState';
import { HeaderTabsState } from '../HeaderTabs';

export const CareRouter: React.FC = () => {

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const tabsProvider = useInstance(CareTabsProvider);

    const tabsState = useInstance(HeaderTabsState);
    useSubscription(() => tabsState);

    return (
        <>
            <Route path="/care-redirect" exact render={() => {
                const lastTab = tabsState.getLastActiveTab('care-tabs');
                const careMap = careMapState.getMostRecentCaremap();
                const isIncomplete = careMap && careMapState.isIncomplete(careMap);
                const notesOnly = careMap && careMapState.hasOnlyNotes(careMap.careMapId);

                let redirectTo: string;
                if (isIncomplete || notesOnly || lastTab?.dataId === 'notes-tab') {
                    redirectTo = `/notes/${careMap?.careMapId}`;
                } else if (lastTab?.dataId === 'caremap-tab') {
                    redirectTo = `/caremaps/${careMap?.careMapId}`;
                } else if (lastTab?.dataId === 'status-tab' && careMap && tabsProvider.offersStatus(careMap)) {
                    redirectTo = `/status/${careMap?.careMapId}`;
                } else {
                    redirectTo = `/care/${careMap?.careMapId}`;
                }

                return (
                    <Redirect to={redirectTo} />
                );
            }} />

            <Route path="/care/:caremapId" exact render={routeParams => {
                const caremapId = routeParams.match.params.caremapId;
                // the profile is a care detail; a reader the api withholds it from has only the notes
                if (careMapState.hasOnlyNotes(caremapId)) {
                    return <Redirect to={`/notes/${caremapId}`} />;
                }
                return <CarePage caremapId={caremapId} />;
            }} />

            <Route path="/status/:caremapId" exact render={routeParams => (
                <CareStatusPage caremapId={routeParams.match.params.caremapId} />
            )} />
        </>
    );
};
